import { DataLogRq, SourcePage } from '@domain/rq/DataLog';
import ProfileViewVO, { PrizeVO } from '@domain/vo/profile/ProfilePrizeVO';
import DateFormat from '@utils/date/format';

export default class ProfilePrizeFormVO {
  prizes: PrizeFormVO[];
  sourcePage?: SourcePage;

  constructor(vo: ProfileViewVO & DataLogRq) {
    this.prizes = vo.prizes.map((item) => new PrizeFormVO(item));
    this.sourcePage = vo.sourcePage;

    //데이터 없을 경우 초기값 셋팅함
    this.initValue();
  }

  initValue() {
    if (this.prizes.length === 0) {
      this.prizes = [
        new PrizeVO({
          institution: '',
          name: '',
          date: '',
          description: '',
        }),
      ];
    }
  }
}

export class PrizeFormVO {
  institution: string;
  name: string;
  date: string;
  description: string;

  constructor(vo: PrizeVO) {
    this.institution = vo.institution;
    this.name = vo.name;
    this.date = this.getDateFormat(vo.date);
    this.description = vo.description;
  }

  getDateFormat(data: string | null) {
    return DateFormat.getDateFormatString(data, 'yyyy-MM') ?? '';
  }
}
